import { NgClass } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalStateService } from './shared/services/global-state.service';
import { AuthService } from './shared/auth-helpers/auth.service';
import { ToastsContainerComponent } from './common/components/toasts-container/toasts-container.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgClass, ToastsContainerComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    protected readonly globalStateService = inject(GlobalStateService);
    protected readonly authService = inject(AuthService);

    ngOnInit() {
        this.authService.refresh();
    }
}
